import { CountryType } from '../../../../types/CountryType'
import { IdCard } from './components/IdCard'
import { PersonalInformation } from './components/PersonalInformation'
import { ResidencePermit } from './components/ResidencePermit'
import { WorkPermit } from './components/WorkPermit'

interface Props {
  countries: CountryType[]
}

export const FormContent = ({ countries }: Props) => {
  return (
    <>
      <PersonalInformation countries={countries} />
      <IdCard countries={countries} />
      <ResidencePermit countries={countries} />
      <WorkPermit countries={countries} />
    </>
  )
}
